import type { AxiosCollection } from '@/types/Components/Response'
import type { AssignmentResponse } from '@/types/Models/Assignment'
import type { ItemData } from '@/types/Models/Item'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class AssignmentProxy extends BaseProxy implements ProxyMethods<AssignmentResponse> {
  public endpoint = 'assignments'

  getItems(assignmentId: string): Promise<AxiosCollection<ItemData>> {
    return this.submit('get', `/${this.endpoint}/${assignmentId}/items`)
  }

  getStatus(assignmentId: string) {
    return this.submit('get', `/${this.endpoint}/${assignmentId}/status`)
  }

  getHistory(assignmentId: string) {
    return this.submit('get', `/${this.endpoint}/${assignmentId}/history`)
  }

  getIntegrationLogs(assignmentId: string) {
    return this.submit('get', `/${this.endpoint}/${assignmentId}/integration-logs`)
  }

  reoptimize(assignmentId: string) {
    return this.submit('post', `/${this.endpoint}/${assignmentId}/reoptimize`)
  }

  recreateLabels(assignmentId: string) {
    return this.submit('post', `/${this.endpoint}/${assignmentId}/recreate-labels`)
  }

  // todo - deprecate this usage
  getLabelsStatuses(assignmentId: string) {
    return this.submit('get', `/${this.endpoint}/${assignmentId}/labels-statuses`)
  }

  validate(assignmentId: string): Promise<AssignmentResponse> {
    return this.submit('post', `/${this.endpoint}/${assignmentId}/validate`)
  }

  getReportData(assignmentId: string) {
    return this.submit('get', `/${this.endpoint}/${assignmentId}/report`)
  }

  createLabels(assignmentId: string): Promise<AssignmentResponse> {
    return this.submit('post', `/${this.endpoint}/${assignmentId}/create-labels`)
  }

  submitOptimize(assignmentId: string): Promise<AssignmentResponse> {
    return this.submit('post', `/${this.endpoint}/${assignmentId}/optimize`)
  }

  getAssignmentDetails(assignmentId: string): Promise<AssignmentResponse> {
    return this.submit('get', `/${this.endpoint}/${assignmentId}?include=item.validationFlags,item.products`)
  }

  getLabelsMultiple(payload: any) {
    return this.submit('post', `/${this.endpoint}/labels/download`, payload)
  }

  attachSourceFile(assignmentId: string, payload: any) {
    return this.submit('post', `/${this.endpoint}/${assignmentId}/file`, payload)
  }

  getErrorSuggestions(assignmentId: string, level: string) {
    const filter = level && level != 'all' ? `?level=${level}` : ''
    return this.submit('get', `/${this.endpoint}/${assignmentId}/errors${filter}`, {})
  }

  applyErrorSuggestions(assignmentId: string, payload: any) {
    return this.submit('put', `/${this.endpoint}/${assignmentId}/errors`, payload)
  }
}
